export const LOCALE_STORAGE_KEY = '0top_ui_locale';

export const LOCALES = ['ja', 'zh-TW'];
